import { Stack } from '@mui/material';

import type { StackProps, SxProps } from '@mui/material';
import type { ReactElement } from 'react';

export interface TextIconLabelProps extends StackProps {
  icon: ReactElement;
  value: any;
  endIcon?: boolean;
  sx?: SxProps;
}

export function TextIconLabel({
  icon,
  value,
  endIcon = false,
  sx,
  ...other
}: TextIconLabelProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        typography: 'body2',
        ...sx,
      }}
      {...other}
    >
      {!endIcon && icon}
      {value}
      {endIcon && icon}
    </Stack>
  );
}
